import type { PerfilUsuario } from '../types/database'

/**
 * Whitelist de rotas para perfis operacionais e Nutricionista ISEN (`fiscal`).
 * Admin não entra aqui → acesso amplo (Configurações ainda bloqueada por adminOnly).
 */
const PERFIL_ROTAS: Partial<Record<PerfilUsuario, readonly string[]>> = {
  responsavel_escola: ['/', '/entregas'],
  logistica: ['/planejamento-rota', '/entregas'],
  nutricionista: ['/', '/calendario', '/ficha-tecnica', '/planejamento-rota', '/entregas', '/estoque'],
  /** Nutricionista ISEN — cardápio, pedido, validação e consulta pós-gate. */
  fiscal: [
    '/',
    '/calendario',
    '/ficha-tecnica',
    '/pedido-mensal',
    '/acompanhamento',
    '/contrato',
    '/auditoria',
    '/entregas',
  ],
}

export function rotasPermitidas(perfil: PerfilUsuario | null | undefined): readonly string[] | null {
  if (!perfil) return null
  return PERFIL_ROTAS[perfil] ?? null
}

export function perfilPodeAcessarPath(
  perfil: PerfilUsuario | null | undefined,
  pathname: string,
): boolean {
  const list = rotasPermitidas(perfil)
  if (!list) return true
  const path = pathname.split('?')[0] || '/'
  return list.some((allowed) => {
    if (allowed === '/') return path === '/'
    return path === allowed || path.startsWith(`${allowed}/`)
  })
}

export function perfilHomePath(perfil: PerfilUsuario | null | undefined): string {
  const list = rotasPermitidas(perfil)
  if (!list || list.includes('/')) return '/'
  return list[0] || '/'
}

/** Valores monetários (R$): Administrador e Nutricionista ISEN (fiscal). */
export function perfilVeValoresMonetarios(perfil: PerfilUsuario | null | undefined): boolean {
  return perfil === 'admin' || perfil === 'fiscal'
}

/**
 * KPIs / painéis agregados de escolas (Dashboard municipal).
 * Nutricionista ISEN (`fiscal`) não vê KPIs municipais — conferência por escola
 * ocorre no detalhe do Pedido / planejamento, não no painel (D-006 / US-U-D06).
 */
export function perfilVeIndicadoresEscolas(perfil: PerfilUsuario | null | undefined): boolean {
  if (!perfil) return false
  return perfil !== 'fiscal'
}
